export default {
  general: {
    filters: "Filters",
    save: "Save",
    cancel: "Cancel",
    add: "Add",
    create: "Create",
    update: "Update",
    download: "Download",
    attachedFile: "Attached file",
    yes: "Yes",
    no: "No",
  },
  routes: {
    reports: {
      main: "Reports",
      dashboard: "Reports",
      show: "Report",
    },
    rpg: {
      main: "RPG",
    },
    questionOfDay: {
      main: "Question of the day",
      list: "Series list",
      review: "Question review",
    },
    hero: {
      main: "Hero",
      form: "Add",
      list: "Slider settings",
      noSerie: "- no linked series -",
      edit: "Edit",
      delete: "Delete",
      description: "Description",
      description2: "Description 2",
      location: "Link (if different than default)",
      description_link: "Link description (if different than default)",
      title: "Title",
      link: "Link",
      type: "Type",
      language: "Language",
      serie: "Series",
      serieAi: "Series (AI School)",
      aiSchool: "AI School",
      image: "Image (web)",
      imageMobile: "Image (mobile)",
      active: "Active",
      ceo: "CEO (new UI)",
      save: "Save",
      send: "Add",
    },
    users: {
      main: "Użytkownicy",
      list: "Lista użytkowników",
    },
    accredible: {
      generate: "Generate certificate",
    },
    points: {
      main: "Points",
      list: "Points Management",
    },
    squad: {
      main: "Zespół",
      list: "Lista zespołów",
      form: "Dodaj zespół",
      edit: "Edytuj zespół",
      add: "Dodaj zespół",
    },
    ceoTeams: {
      main: "CEO Teams",
      list: "CEO teams list",
      form: "Add CEO team",
    },
    ceoLivewebinars: {
      main: "CEO live recordings",
      list: "CEO live recordings",
      form: "Add live recording",
    },
    ceoWorkshops: {
      main: "CEO workshops",
      list: "CEO workshops",
      form: "Add workshop",
    },
    aiSchool: {
      main: "AI Practitioners School",
      list: "AI Practitioners School",
    },
    materialZone: {
      main: "Material Zone",
      elements: "Materials List",
      addElement: "Add material",
      editElement: "Edit material",
      slides: "Slides List",
      addSlide: "Add slide",
      editSlide: "Edit slide",
      boardmeetingMaterials: "Boardmeeting Materials",
      addBoardmeetingMaterial: "Add boardmeeting material",
      editBoardmeetingMaterial: "Edit boardmeeting material",
    },
    boardmeetingChallengeLiveSessions: {
      main: "Boardmeeting Live",
      list: "Live sessions list",
      form: "Add live session",
    },
  },
  options: {
    materialZone: {
      placeholder: "Material",
      search: "Search material",
    },
  },
  search: "Search",
  save: "Save",
  cancel: "Cancel",
  name: "Name",
  surname: "Surname",
  email: "Email",
  actions: "Actions",
  user: "User",
  previous: "Previous",
  next: "Next",
  acceptDelete: "Are you sure you want to delete?",
};
